import React from 'react';

type Props = {
  onAdd: (e?: React.MouseEvent<HTMLButtonElement>) => void;
  label?: string;
  disabled?: boolean;
};

const AddButton: React.FC<Props> = ({ onAdd, label = 'Adicionar', disabled = false }) => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    onAdd(e);
  };

  return (
    <button className="btn btn-primary" disabled={disabled} type="button" onClick={handleClick}>
      {label}
    </button>
  );
};

export default AddButton;
